import * as React from 'react';

import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { Label } from 'office-ui-fabric-react/lib/Label';

import { Config } from './Config.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';


import './css/Site.css';
import './css/Home.css';
import './css/DialogBox.css';

/* NON TOCCARE, spariscono le icone */
initializeIcons();

const session = new Session();
const config = new Config();
const utils = new Utils();

export class DeleteAccount extends React.Component {
    
    constructor(){
        super();
        this.state = {
            mostraEliminaAccount : '',
            mostraAccountEliminato : 'nascosto',

            mostraMexErrore : 'nascosto',

            txtEliminaAccount : '',
            txtAccountEliminato : ''
        };
        
        this.impostaParametriPagina = this.impostaParametriPagina.bind(this);
        this.eliminaAccountVersionePEF = this.eliminaAccountVersionePEF.bind(this);
    }
    
    
    impostaParametriPagina()
    { 
        // visualizzazione BOX COMMERCIALE
       let mexDelete =  utils.getObjInfoSocieta( 'MEX_DELETE_ACCOUNT' , 'Cliccando questo bottone esprimi la volontà di cancellare il tuo account.' );
       let mexPostDelete =  utils.getObjInfoSocieta( 'MEX_POST_DELETE_ACCOUNT' , "IL TUO ACCOUNT E' STATO RIMOSSO DALL'AREA CLIENTI" );
        
       this.setState( {txtEliminaAccount:mexDelete , txtAccountEliminato:mexPostDelete } );
    }
    
    esciDaAC2(){
        utils.logout();
    }
    
    eliminaAccountVersionePEF(){

        // riferimento Ticket #66880 - MN - mockup fornito da PEFPOWER per cancellazione password
        // Per SINERGY al momento invece la cancellazione avviene con un popup e inserisce il record in MS030_BLOCCATI

        let request = new Request( config.get("customers_cancellapassword") ,{
            method: 'POST',mode: 'cors', credentials: "include",
            body: JSON.stringify({id_cliente: session.get('id_cliente')})
        });

        fetch(request)
        .then(function(response){
            return response.json();
        })
        .then(function(result){
            if (result.success){

                if( result.data.id_cliente === session.get('id_cliente') ){
                    //utils.logout();
                    this.setState( {mostraEliminaAccount:'nascosto' , mostraAccountEliminato:'' } );
                    // Se ha eseguito la cancellazione, nascondo anche il menu principale
                    // document.getElementById('mainMenu').style.display='none';
                } else {
                    // se mi arriva un ID DIVERSO per me si tratta di un errore
                    this.setState( {mostraEliminaAccount:'nascosto' , mostraAccountEliminato:'nascosto', mostraMexErrore:'' } );
                }
            } else {
                this.setState( {mostraEliminaAccount:'nascosto' , mostraAccountEliminato:'nascosto', mostraMexErrore:'' } );
            }
        }.bind(this) );
    }
    
    componentDidMount() {

        this.impostaParametriPagina();
        utils.setBoxInfoCliente();
    }
    
    
    
    render(){
        return ( 
            <div id="inner-container">    
                <Label className='ms-fontSize-xxl titolo-pagina'>Elimina il tuo Account<span id='boxdettagliocliente'></span></Label>

                <br/><br/>
                <div id="messaggioIniziale" className={this.state.mostraEliminaAccount} dangerouslySetInnerHTML={{__html: this.state.txtEliminaAccount}}></div>
                    

                <div className={"bottonElimina "+ this.state.mostraEliminaAccount}>
                    <div>VUOI CONTINUARE?</div>
                    <PrimaryButton id="confermaEliminaBtnPassword" text="SI" onClick={() => this.eliminaAccountVersionePEF()} />
                </div>
                
                <div className={"bottonElimina "+ this.state.mostraAccountEliminato} dangerouslySetInnerHTML={{__html: this.state.txtAccountEliminato}}></div>
                <div className={"bottonElimina "+ this.state.mostraAccountEliminato}>
                    <PrimaryButton id="esciEliminaBtnPassword" text="ESCI" onClick={() => this.esciDaAC2()} />
                </div>
                
                <div className={"bottonElimina "+ this.state.mostraMexErrore}>Si è verificato un Errore. Contattare l'amministratore di sistema.</div>

            </div>
        );
    }
}

export default DeleteAccount;


// WEBPACK FOOTER //
// ./src/AcComponents/DeleteAccount.js